import { createContext } from 'react';

interface GarageContext {
  closeGarage?: () => void;
  doNotRedirectOnVehicleSelect?: true;
  isAutoVehicleSelectionDisabled?: boolean;
  isShowVehicleDropdowns?: boolean;
  redirectUrl?: string;
  showVehicleDropdowns?: () => void;
  useNativeDropdown?: false;
  useVehicleWidget?: true;
  isVehicleSelected?: true;
  discardSelectedVehicle?: () => void;
}

export default createContext<GarageContext>({});
